export type AddAllToCartHeaderKey =
    | 'addedOne'
    | 'addedMultiple'
    | 'titleAddedNone'
    | 'titleAddedOneUnavailable'
    | 'titleAddedNoneUnavailable';

export type AddAllToCartSecondaryKey = 'addedNone' | 'unavailableItems';

export type AddAllToCartToastUi = {
    headerKey: AddAllToCartHeaderKey;
    secondaryKey: AddAllToCartSecondaryKey | null;
    showCartIcon: boolean;
    isHeadingTitle: boolean;
};

/** Maps add-all-to-cart counts to header, secondary banner, and cart icon visibility. */
export function resolveAddAllToCartToastUi({
    addedItemCount = 0,
    unavailableItemCount = 0,
    isBasketQuotaExceeded = false,
}: {
    addedItemCount?: number;
    unavailableItemCount?: number;
    isBasketQuotaExceeded?: boolean;
}): AddAllToCartToastUi {
    const added = addedItemCount;
    const unavailable = unavailableItemCount;
    const quota = isBasketQuotaExceeded;

    let headerKey: AddAllToCartHeaderKey = 'titleAddedNoneUnavailable';

    if (added > 1) {
        headerKey = 'addedMultiple';
    } else if (added === 1) {
        headerKey = 'addedOne';
    } else if (quota) {
        headerKey = 'titleAddedNone';
    } else if (unavailable === 1) {
        headerKey = 'titleAddedOneUnavailable';
    }

    let secondaryKey: AddAllToCartSecondaryKey | null = null;

    if (quota) {
        secondaryKey = 'addedNone';
    } else if (unavailable > 0) {
        secondaryKey = 'unavailableItems';
    }
    const isHeadingTitle = headerKey.startsWith('titleAdded');

    return {
        headerKey,
        secondaryKey,
        showCartIcon: added > 0,
        isHeadingTitle,
    };
}
